export default "__VITE_ASSET__DtQkugDk__"